module.exports = __webpack_public_path__ + "static/media/workflow.304fa0a3.svg";